import React, { useState } from "react";
import { Walkaround } from "../../../logic/api";
import flex from "../../../styles/flex";
import { IconButton } from "@mui/material";
import { FiEdit, FiTrash } from "react-icons/fi";
import { FaUndo } from "react-icons/fa";
import ConfirmationDialog from "../../../components/notifications/confirmationDialog/ConfirmationDialog";
import { useTranslation } from "react-i18next";

export interface IWalkaroundListItemProps {
    item: Walkaround;
    onEdit: () => void;
    onDelete: () => void;
    onRestore: () => void;
}
export const WalkaroundListItem: React.FC<IWalkaroundListItemProps> = (props) => {
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const { t } = useTranslation();

    const handleDeleteConfirmationResult = (result: boolean) => {
        setShowDeleteConfirmation(false);
        if (result) {
            props.onDelete();
        }
    }
    return (
        <div style={
            {
                border: "solid 1px lightgray",
                padding: 10,
                borderRadius: 5,
                marginBottom: 5, opacity: props.item.active == true ? 1 : 0.8
            }
        }>
            <div style={{ ...flex.flexRows, justifyContent: "center", alignItems: "center" }}>
                <div style={{ ...flex.flexAuto, minWidth: 20 }}> </div>
                <div style={flex.flexFill}>
                    <div><b>{props.item.name}</b>  {props.item.active != true && (<small style={{ color: "red" }}><b>{t("walkarounds.deleted")}</b></small>)}</div>
                    <div>{props.item.abbrev}</div>
                </div>

                <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                    <div>
                        <IconButton
                            onClick={() => {
                                props.onEdit();
                            }}>
                            <FiEdit></FiEdit>
                        </IconButton>
                        <div><small>{t("general.edit")}</small></div>
                    </div>
                </div>
                {props.item.active == true && (<div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                    <div>
                        <IconButton
                            onClick={() => {
                                setShowDeleteConfirmation(true);
                            }}>
                            <FiTrash></FiTrash>
                        </IconButton>
                        <div><small>{t("general.delete")}</small></div>
                    </div>
                </div>)}
                {props.item.active == false && (
                    <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                        <div>
                            <IconButton
                                onClick={() => {
                                    props.onRestore();
                                }}>
                                <FaUndo></FaUndo>
                            </IconButton>
                            <div><small>{t("general.restore")}</small></div>
                        </div>
                    </div>
                )}
            </div>
            <ConfirmationDialog title={t("walkarounds.deleteWalkaround")} message={t("walkarounds.confirmDeleteWalkaround")} show={showDeleteConfirmation} onClose={handleDeleteConfirmationResult} />
        </div>
    );


};